import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  shareVisibilityReport,
  unshareVisibilityReport,
} from '../../services/visibility-report/VisibilityReportService';
import { GET_VISIBILITY_REPORT, GET_VISIBILITY_REPORTS } from '../../query/visibility-report/keys';

/**
 * Włącza/wyłącza publiczny link. `reportId` idzie w zmiennych mutacji, a nie w argumencie hooka —
 * lista raportów obsługuje z jednej instancji każdy wiersz.
 */
export const useShareVisibilityReport = (projectId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ reportId, enabled }: { reportId: number; enabled: boolean }) =>
      enabled ? shareVisibilityReport(reportId) : unshareVisibilityReport(reportId),
    onSuccess: (_data, { reportId }) => {
      void queryClient.invalidateQueries({ queryKey: [GET_VISIBILITY_REPORT, reportId] });
      void queryClient.invalidateQueries({ queryKey: [GET_VISIBILITY_REPORTS, projectId] });
    },
  });
};
